import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MarketplaceFlagComponent, MODAL_DATA, ModalRef } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { AccountMarketplace } from "@front/m19-api-client";

@Component({
  selector: "app-data-warehouse-list-account-marketplace-modal",
  imports: [TranslocoDirective, MarketplaceFlagComponent],
  templateUrl: "./data-warehouse-list-account-marketplace-modal.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataWarehouseListAccountMarketplaceModalComponent {
  protected readonly modalRef = inject(ModalRef);
  protected readonly accountMarketplaces = inject<AccountMarketplace[]>(MODAL_DATA);
}
